import { Component } from '@verndale/core';
import $ from 'jquery';

class ModelsForBrand extends Component {
  setupDefaults() {
    this.dom = {};
    this.initBrandSibling();
  }

  addListeners() {}

  /* eslint-disable */
  initBrandSibling() {
    var $newMakeListWithFilterSection = $('section.new-make-list.has-filter');
    if ($newMakeListWithFilterSection.length) {
      var $makeFilters = $newMakeListWithFilterSection.find('.sb-select'),
        $makeContainers = $newMakeListWithFilterSection.find('.make-list li'),
        $clearFilters = $newMakeListWithFilterSection.find('.clear-filters');

      function resetMakes() {
        $makeFilters.val('');
        $makeContainers.show();
        $clearFilters.removeClass('active').attr('tabindex', '-1');
      }

      $makeFilters.change(function (e) {
        e.preventDefault();
        var $this = $(this),
          rel = $this.attr('rel'),
          attributeSelectors = $makeFilters
            .map(function (i, el) {
              var $el = $(el);
              if ($el.val() !== '') {
                return '[data-' + $el.attr('rel') + '*="|' + $el.val() + '|"]';
              }
            })
            .get();

        if (attributeSelectors && attributeSelectors.length) {
          $makeContainers.hide().filter(attributeSelectors.join('')).show();
          $clearFilters.addClass('active').attr('tabindex', '0');
        } else {
          resetMakes();
        }
      });

      $newMakeListWithFilterSection.find('.clear-filters').click(function (e) {
        e.preventDefault();
        resetMakes();
      });
    }
  }
}

export default ModelsForBrand;
